/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path apihooks
 * @description Measurevalues endpoint
 */
import useHttpEndpoint from "./useHttpEndpoint";
export interface MeasurePayload {
  wfId: string;
  values: MeasureValuePayload[];
}
export interface MeasureValuePayload {
  elementId: string;
  series: string;
  period?: string;
  value: string | number;
}
const useMeasureValues = () =>
  useHttpEndpoint<MeasurePayload>("workflow/measureValues");
export default useMeasureValues;
